<template>
    <v-card color="inverseGrey" :height="dynamicVCardHeight" class="text-center rounded-xl">

        <div class="v-card-container">
            <v-row no-gutters class="index-card-container">
                <div ref="textCreationIndexCard" class="index-card front-card" :class="animationClass" @animationend="resetAnimation" :style="dynamicIndexCardWidthHeight">
                    <div class="left-zone" @click.stop="triggerAnimation('shuffle-to-front')"></div>
                    <div class="right-zone" @click.stop="triggerAnimation('shuffle-to-back')"></div>
                    <v-card-title :style="dynamicFontSizeFrontCard" class="justify-center mx-xl-10 mx-lg-10 font-weight-medium black--text">{{textPost.textAdded[textCardIndexAssociationValue]}}</v-card-title>
                </div>
                <div class="index-card back-card" :style="dynamicIndexCardWidthHeight">
                    <v-card-title :style="dynamicFontSizeBackCard" class="justify-center mx-xl-15 mx-lg-10 font-weight-medium black--text">{{textPost.textAdded[textCardIndexAssociationValue+1]}}</v-card-title>
                </div>
            </v-row>
            <v-divider/>
            <v-row no-gutters justify="space-between" align-content="center" class="actions-container">
                <div class="v-card-actions-left-zone" @click.stop="triggerAnimation('shuffle-to-front')"></div>
                <div class="v-card-actions-right-zone" @click.stop="triggerAnimation('shuffle-to-back')"></div>

                <v-btn icon x-large :disabled="textCardIndexAssociationValue <= 0" @click.stop="triggerAnimation('shuffle-to-front')"><v-icon>mdi-chevron-left-circle</v-icon></v-btn>
                <span style="font-size: 115%; font-weight: bold; border: 2px solid var(--v-accent-base); border-radius: 50%; width: 1.75rem; height: 1.75rem; display: inline-flex; align-self: center; align-items: center; justify-content: center;" class="accent--text">{{ textCardIndexAssociationValue + 1 }}</span>
                <v-btn icon x-large :disabled="textCardIndexAssociationValue >= (textPost.textAdded.length - 1)" @click.stop="triggerAnimation('shuffle-to-back')"><v-icon>mdi-chevron-right-circle</v-icon></v-btn>
            </v-row>
        </div>

    </v-card>
</template>

<script>
// import html2canvas from 'html2canvas';

export default {
    name: "TextIndexView",
    props: ["textPost", "textCardIndexAssociationValue", "triggerAnimationAfterRecord"],
    data: function () {
        return {
            screenHeight: window.innerHeight,
            screenWidth: window.innerWidth,

            animationClass: '',

            direction: "",
        };
    },
    methods: {
        triggerAnimation: function (animationType) { // Logic to update text index and trigger animation
            const canGoForward =
                ((animationType === 'shuffle-to-back') && (this.textCardIndexAssociationValue+1 <= (this.textPost.textAdded.length - 1)));

            const canGoBackward =
                ((animationType === 'shuffle-to-front') && (this.textCardIndexAssociationValue-1 >= 0));

            if (!canGoForward && !canGoBackward) return;

            this.animationClass = animationType;
            this.direction = canGoForward ? 'next' : 'previous';

            if (canGoBackward) this.$emit('textIndexChevronPressed', this.direction);
        },
        resetAnimation: function () {
            this.animationClass = ''; // Remove animation class after animation ends
            if (this.direction === "next") { 
                this.$emit('textIndexChevronPressed', this.direction);
            }
        },
    },
    watch: {
        'triggerAnimationAfterRecord': {
            handler: function(value){
                if (value) this.triggerAnimation('shuffle-to-back');
            }
        },
    },
    computed: {
        dynamicVCardHeight () {
            if (this.$vuetify.breakpoint.xl) {
                // console.log("XL");
                return "40vh"
            } else if (this.$vuetify.breakpoint.lg) {
                // console.log("LG");
                return "45vh"
            } else if (this.$vuetify.breakpoint.md) {
                // console.log("MD");
                return "45vh"
            } else if (this.$vuetify.breakpoint.sm) {
                // console.log("SM");
                return "45vh"
            } else {
                // console.log("XS");
                return "45vh"
            }
        },
        dynamicIndexCardWidthHeight () {
            // console.log("width: ", this.$vuetify.breakpoint.width);
            // console.log("screenWidth: ", this.screenWidth);
            if (this.$vuetify.breakpoint.xl) {
                // console.log("XL");
                return {width: '45%', height: '80%'}
                // return {width: '65%', height: '75%'}
            } else if (this.$vuetify.breakpoint.lg) {
                // console.log("LG");
                return {width: '60%', height: '65%'}
            } else if (this.$vuetify.breakpoint.md) {
                // console.log("MD");
                return {width: '65%', height: '50%'}
            } else if (this.$vuetify.breakpoint.sm) {
                // console.log("SM");
                return {width: '65%', height: '70%'}
            } else {
                // console.log("XS");
                return {width: '100%', height: '70%'}
            }
        },
        dynamicFontSizeFrontCard () {
            const text = this.textPost.textAdded[this.textCardIndexAssociationValue] || '';
            const length = text.length;

            let fontSize = '1.75rem'; // default

            if (length > 120) {
                fontSize = '1.25rem';
            } else if (length > 90) {
                fontSize = '1.5rem';
            } else if (length > 60) {
                fontSize = '1.75rem';
            } else if (length > 30) {
                fontSize = '2rem';
            } else {
                fontSize = '2.25rem';
            }

            return {
                // fontSize: '30px',
                fontSize,
                height: '100%',
                lineHeight: 1.25,
                overflowWrap: 'break-word',
                wordWrap: 'break-word',
                wordBreak: 'break-word',
            };
        },
        dynamicFontSizeBackCard () {
            const text = this.textPost.textAdded[this.textCardIndexAssociationValue+1] || '';
            const length = text.length;

            let fontSize = '1.75rem'; // default

            if (length > 120) {
                fontSize = '1.25rem';
            } else if (length > 90) {
                fontSize = '1.5rem';
            } else if (length > 60) {
                fontSize = '1.75rem';
            } else if (length > 30) {
                fontSize = '2rem';
            } else {
                fontSize = '2.25rem';
            }

            return {
                // fontSize: '30px',
                fontSize,
                height: '100%',
                lineHeight: 1.25,
                overflowWrap: 'break-word',
                wordWrap: 'break-word',
                wordBreak: 'break-word',
            };
        },
    },
    mounted: function () {
        // console.log("this.textPost: ", this.textPost);
    },
    created: function() {},
    // updated: function () {},
    // beforeDestroy: function() {},
    // destroyed: function() {},
};
</script>

<style scoped>
@media (max-width: 600px) {
  .index-card-container {
    position: relative;
    width: 100%;
    height: 85% !important;
    /* border: red solid 1px; */
    justify-content: center !important;
    /* align-self: center ! important; */
    /* align-items: center ! important; */
    align-content: center ! important;
  }

  .index-card {
    position: absolute;
    font-size: 1.5rem;
    /* align-self: center !important; */
  }

  /* .v-card-title {
    font-size: 1.5rem !important;
    padding: 0 12px;
  } */

  .actions-container {
    height: 15% !important;
    flex-wrap: nowrap;
  }
}


.left-zone,
.right-zone {
    position: absolute;
    top: 0;
    width: 50%; /* Half of the card width */
    height: 100%; /* of the card height */
    z-index: 1; /* Ensure it's above the content */
}
.left-zone {
    left: 0;
    cursor: pointer;
}
.right-zone {
    right: 0;
    cursor: pointer;
}

.v-card-container {
    position: absolute;
    width: 100%;
    height: 100%;
    perspective: 1000px;
}

.index-card-container {
    position: relative;
    width: 100%;
    height: 85%;
    justify-content: center;
    align-content: center;
}

.index-card {
    position: absolute;
    align-self: center;
    border-radius: 12px;
    box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.2);
    border: 1px solid #ccc;

    background: repeating-linear-gradient(
        to bottom,
        white 0px,
        white 20px,
        #cce7ff 21px
    );
}

.index-card::before { /* Simulating red horizontal line on index card */
    content: "";
    position: absolute;
    top: 1.50rem;
    left: 0;
    width: 100%;
    height: 2px;
    background: #ff0000;
    z-index: 1;
}

/* Front Side */
.front-card {
    z-index: 2;
}

/* Back Side */
.back-card {
    z-index: 1;
}

.shuffle {
    animation: shuffleCard 0.75s ease-in-out;
}

/* .shuffle-to-back {
    animation: shuffleCard 0.8s ease-in-out;
}
.shuffle-to-front {
    animation: shuffleCardReverse 0.8s ease-in-out;
} */
.shuffle-to-back {
    animation: shuffleCard 1.0s ease-in;
}
.shuffle-to-front {
    animation: shuffleCardReverse 0.8s ease-in;
}

@keyframes shuffleCard {
    0% {
        transform: scale(1) translateY(0) rotate(0deg);
        opacity: 1;
        z-index: 10;
    }
    25% {
        transform: scale(0.50) translateY(-125%) translateX(120%) rotate(30deg);
        opacity: 0.50;
    }
    50% {
        transform: scale(0.25) translateY(-200%) translateX(200%) rotate(45deg);
        opacity: 0.25;
    }
    75% {
        transform: scale(0.1) translateY(-250%) translateX(250%) rotate(30deg);
        opacity: 0.00;
    }
    100% {
        transform: scale(0.0) translateY(0) rotate(0deg);
        opacity: 0;
    }
}
@keyframes shuffleCardReverse {
    0% {
        transform: scale(0.0) translateY(0) rotate(0deg);
        opacity: 0;
    }
    25% {
        transform: scale(0.1) translateY(-250%) translateX(250%) rotate(30deg);
        opacity: 0.00;
    }
    50% {
        transform: scale(0.25) translateY(-200%) translateX(200%) rotate(45deg);
        opacity: 0.25;
    }
    75% {
        transform: scale(0.50) translateY(-125%) translateX(120%) rotate(30deg);
        opacity: 0.50;
    }
    100% {
        transform: scale(1) translateY(0) rotate(0deg);
        opacity: 1;
        z-index: 10;
    }
}

.actions-container {
    position: relative;
    width: 100%;
    height: 15%;
}

.v-card-actions {
    align-items: center;
    justify-content: space-between;
}

.v-card-actions-left-zone,
.v-card-actions-right-zone {
    position: absolute;
    bottom: 0;
    width: 45%; /* Half of the card width */
    height: 100%; /* of the card height */
    z-index: 1; /* Ensure it's above the content */
}
.v-card-actions-left-zone {
    left: 0;
    cursor: pointer;
}
.v-card-actions-right-zone {
    right: 0;
    cursor: pointer;
}
</style>